// Simple in-process pub/sub used to bridge the ported `Vehicles` module
// (which originally sent IPC messages via mainWindow.webContents.send) to
// the renderer's `window.api` shim.
//
// Channels match the original Electron IPC channel names so consumer code
// in src/renderer/* keeps working without changes.

class EventBus {
    constructor() {
        this._channels = new Map();
    }

    on(channel, listener) {
        let set = this._channels.get(channel);
        if (!set) { set = new Set(); this._channels.set(channel, set); }
        set.add(listener);
    }

    off(channel, listener) {
        const set = this._channels.get(channel);
        if (!set) return;
        set.delete(listener);
    }

    emit(channel, ...args) {
        const set = this._channels.get(channel);
        if (!set || set.size === 0) return;
        // Mimic Electron's `(event, ...args)` callback signature with a stub event.
        const stubEvent = { channel };
        for (const listener of Array.from(set)) {
            try { listener(stubEvent, ...args); }
            catch (err) { console.error('EventBus listener error', channel, err); }
        }
    }

    once(channel, listener) {
        const wrap = (event, ...args) => {
            this.off(channel, wrap);
            listener(event, ...args);
        };
        this.on(channel, wrap);
    }
}

const eventBus = new EventBus();

export default eventBus;
export { EventBus };
